"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateHeaders = exports.restClient = void 0;
var axios_1 = __importDefault(require("axios"));
var localstorage_1 = require("./localstorage");
var restClient = function (url) {
    var saasToken = localstorage_1.getTokens().saasToken;
    var headers = {
        'Content-Type': 'application/json',
    };
    if (saasToken) {
        headers.Authorization = saasToken;
    }
    return axios_1.default.create({
        baseURL: url,
        timeout: 60000,
        headers: headers,
    });
};
exports.restClient = restClient;
var updateHeaders = function (instance, headers) {
    if (!instance)
        return;
    // Unfortunately axios headers is set as any
    // also this is the rare case where there is params mutation to keep same instance across app
    var entries = Object.entries(__assign(__assign({}, instance.defaults.headers), headers));
    var cleanHeaders = entries.reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        if (value) {
            return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
        }
        return acc;
    }, {});
    // eslint-disable-next-line no-param-reassign
    instance.defaults.headers = cleanHeaders;
};
exports.updateHeaders = updateHeaders;
